import React from 'react';

import ContactsIcon from '@mui/icons-material/Contacts';

import RelatedListCard from '../RelatedListCard';
import RelatedTileGrid from '../RelatedTileGrid';
import { RELATED_PREVIEW_LIMIT, accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';

import AccountContactTile from './AccountContactTile';
import { useAccountContacts } from './useAccountContacts';

interface Props {
  accountId: string;
}

export default function AccountContactsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { contacts, error, isLoading } = useAccountContacts(accountId);

  return (
    <RelatedListCard
      count={contacts.length}
      error={error}
      icon={<ContactsIcon color="action" />}
      isLoading={isLoading}
      isSampleData
      title="Contacts"
      viewAllTo={accountPath(accountId, offerId, '/contacts')}
    >
      <RelatedTileGrid>
        {contacts.slice(0, RELATED_PREVIEW_LIMIT).map((contact) => (
          <AccountContactTile key={contact.id} contact={contact} />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
